document.addEventListener("DOMContentLoaded", function() {
//   gsap.registerPlugin(ScrollTrigger);

    // gsap.to(".wrapper-feature-star-left img", {
    //     rotation: 180,          
    //     duration: 3,           
    //     ease: "power2.inOut",
    //     scrollTrigger: {
    //     start: "top center",          
    //     toggleActions: "play none none none" 
    //     }
    // });
    // gsap.to(".wrapper-feature-star-right img", {
    //     rotation: 180,          
    //     duration: 3,           
    //     ease: "power2.inOut",
    //     scrollTrigger: {
    //         trigger: ".featured-collections",
    //         start: "center center",          
    //         toggleActions: "play none none none" 
    //     }
    // });
    // gsap.to(".custom-swiper-section .wrapper-feature-star-left img", {
    //     rotation: 180,          
    //     duration: 3,           
    //     ease: "power2.inOut",
    //     scrollTrigger: {
    //         trigger: ".custom-swiper-section",
    //         start: "top center",          
    //         toggleActions: "play none none none" 
    //     }
    // });

    // Left star hover
    document.querySelectorAll(".wrapper-feature-star-left img").forEach(img => {
    img.addEventListener("mouseenter", () => {
        gsap.to(img, {
        rotation: 45,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });

    img.addEventListener("mouseleave", () => {
        gsap.to(img, {
        rotation: 0,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });
    });

    // Right star hover
    document.querySelectorAll(".wrapper-feature-star-right img").forEach(img => {
    img.addEventListener("mouseenter", () => {
        gsap.to(img, {
        rotation: 45,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });

    img.addEventListener("mouseleave", () => {
        gsap.to(img, {
        rotation: 0,
        duration: 1.5,
        ease: "power2.inOut"
        });
    });
    });
        
   
   var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 4000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    freeMode: true,
    freeModeMomentum: false,
    allowTouchMove: false,
    breakpoints: {
        1920: {
        slidesPerView: 5,
        spaceBetween: 20
        },
        1366: {
        slidesPerView: 4,
        spaceBetween: 20
        },
        1024: {
        slidesPerView: 3,
        spaceBetween: 20
        },
        768: {
        slidesPerView: 3,
        spaceBetween: 20
        },
        767: {
        slidesPerView: 0.8,
        spaceBetween: 20,
        allowTouchMove: false,
        autoplay: true
        }
    }
    });



    let tl = gsap.timeline();

    gsap.to("#svg-logo #letter-B" , {
        duration: 1.5,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });

    gsap.to("#svg-logo #letter-butree" , {
        duration: 3,
        strokeDasharray: 3000,
        stagger: .15,
        transformOrigin: "center"
    });
    tl.to("#svg-logo #letter-dy" , {
        duration: 1,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });
    gsap.to("#svg-logo #letter-o" , {
        duration: 1.5,
        strokeDasharray: 1500,
        stagger: .15,
        transformOrigin: "center"
    });

    gsap.to(" #svg-logo #letter-cean" , {
        duration: 3,
        strokeDasharray: 1000,
        stagger: .15,
        transformOrigin: "center"
    });
    tl.fromTo(
        "#svg-logo #brid-1, #svg-logo #brid-2",
        { fill: "transparent", },   // from color
        { fill: "#ffffff", duration: 1 } // to color
    );
    tl.to(
        "#svg-logo #letter-B, #svg-logo #letter-butree, #svg-logo #letter-dy, #svg-logo #letter-o, #svg-logo #letter-cean",
        {
            fill: "#ffffff", 
            duration: 0.5 ,
            stroke: "#ffffff"    
        }
    );

    var input = document.querySelector("#ContactForm-phone");
    window.intlTelInput(input, {
    initialCountry: "US",
    separateDialCode: true,
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.13/js/utils.min.js",
    // ye line bohot important hai ↓
    loadUtilsOnInit: true
    });
    document.querySelector('.iti__flag-container , .iti__flag').style.backgroundImage = "url('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.13/img/flags.png')";



});